module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/celcium-00755b35c867b46b77394f616cb484a7.svg";